import React from "react";
import { formatAudAmount } from "../../../utils/audCurrency";

const BookingSummary = ({
  tutor,
  selectedTime,
  formattedDate,
  duration,
  onContinue,
  isPaymentEnabled,
  continueLabel,
  paymentBadgeLabel,
  paymentBadgeTone = "warning",
  statusDescription,
  isPaymentDisabled = false,
  bookingStatusLabel,
  variant = "default",
}) => {
  const isParentVariant = variant === "parent";
  const badgeClasses =
    paymentBadgeTone === "success"
      ? isParentVariant
        ? "border border-green-200 bg-[#f3fff2] text-green-700"
        : "border border-green-200 bg-green-50 text-green-700"
      : isParentVariant
        ? "border border-[#f1cf6a] bg-[#fffaf0] text-[#c46b10]"
        : "border border-amber-200 bg-amber-50 text-amber-700";
  const bookingStatusValue = String(bookingStatusLabel || "").trim();
  const parentStatusClasses =
    paymentBadgeTone === "success" ? "text-green-700" : "text-[#9ca3af]";
  const statusDescriptionClasses = isParentVariant
    ? "border-[#d9dde5] bg-[#f5f7fb] text-[#596274]"
    : "border-gray-200 bg-gray-50 text-gray-600";

  return (
    <div
      className={`flex h-full w-full flex-col rounded-2xl border shadow-md p-8 ${
        isParentVariant
          ? "border-[#ddd3c6] bg-[#fffaf4]"
          : "border-gray-200 bg-white"
      }`}
    >
      <div className="mb-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="text-gray-900 font-semibold">Booking Summary</h3>
          {bookingStatusValue ? (
            isParentVariant ? (
              <p
                className={`mt-3 text-xs font-medium uppercase tracking-[0.18em] leading-[1.35] ${parentStatusClasses}`}
              >
                Booking status:
                <br />
                {bookingStatusValue}
              </p>
            ) : (
              <p className="mt-1 text-xs font-medium uppercase tracking-[0.14em] text-gray-400">
                Booking status: {bookingStatusValue}
              </p>
            )
          ) : null}
        </div>
        {paymentBadgeLabel ? (
          <span
            className={`shrink-0 whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-semibold ${badgeClasses}`}
          >
            {paymentBadgeLabel}
          </span>
        ) : null}
      </div>

      <div className="space-y-4 text-sm">
        <div>
          <p className="text-gray-500">Tutor</p>
          <p className="font-medium text-gray-900">{tutor.name}</p>
        </div>

        <div>
          <p className="text-gray-500">Date</p>
          <p className="font-medium text-gray-900">{formattedDate}</p>
        </div>

        <div>
          <p className="text-gray-500">Time</p>
          <p className="font-medium text-gray-900">
            {selectedTime || "Not selected"}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Duration</p>
          <p className="font-medium text-gray-900">{duration || "60 minutes"}</p>
        </div>
      </div>

      <div className="mt-auto pt-6 space-y-4">
        <div
          className={`rounded-xl p-4 border ${
            isParentVariant
              ? "border-[#eadfcd] bg-[#fcf7ef]"
              : "border-gray-200 bg-gray-50"
          }`}
        >
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Session Fee</span>
            <span className="font-medium text-gray-900">
              {formatAudAmount(tutor.price)}
            </span>
          </div>

          <div className="flex justify-between mt-2 text-sm">
            <span className="text-green-600 font-medium">Total Amount</span>
            <span className="text-green-600 font-medium">
              {formatAudAmount(tutor.price)}
            </span>
          </div>
        </div>

        {statusDescription ? (
          <div
            className={`rounded-xl border px-4 py-3 text-sm ${statusDescriptionClasses}`}
          >
            {statusDescription}
          </div>
        ) : null}

        <button
          onClick={onContinue}
          className={`w-full py-3 rounded-xl shadow-md font-medium transition
            ${
              isPaymentEnabled && !isPaymentDisabled
                ? isParentVariant
                  ? "bg-[#08059B] text-white hover:bg-[#01044F]"
                  : "bg-[#0736D6] text-white hover:bg-[#062FC0]"
                : "bg-gray-200 text-gray-500 cursor-not-allowed"
            }
          `}
          disabled={!isPaymentEnabled || isPaymentDisabled}
        >
          {continueLabel || "Continue to Payment"}
        </button>
      </div>
    </div>
  );
};

export default BookingSummary;
